var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { H4 } from "@irati/ui/src/Headings";
var StyledH4 = styled(H4)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 40px 0 60px;\n"], ["\n  margin: 40px 0 60px;\n"])));
export default StyledH4;
export var FormSectionHeading = styled(H4)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n  margin: 20px 0;\n"], ["\n  text-align: left;\n  margin: 20px 0;\n"])));
var templateObject_1, templateObject_2;
